import React from 'react';
import styles from './index.less';
import classNames from 'classnames';

const GradientBorderBox = ({children, className, containerClassName, gradientBorder = true}) => {
  return <div className={classNames({
    [styles.gradientBorder]: gradientBorder,
  }, containerClassName)}>
    <div className={classNames(styles.gradientBorderContent, className)}>
      {children}
    </div>
  </div>
}

export default GradientBorderBox;
